<hx-form-group class="hx-form-group">
  @if (label()) {
    <hx-label
      [description]="label()"
      [required]="required()"
      [subtitle]="sublabel() || ''"
      [fontWeight]="labelFontWeight()"
      [fontSize]="labelFontSize()"
      [subtitleFontWeight]="subtitleFontWeight()"
      [subtitleFontSize]="subtitleFontSize()"
      [color]="labelColor()"
      [subtitleColor]="subtitleColor()"
      [tooltip]="tooltip()"
      [tooltipPosition]="tooltipPosition()"
      [tooltipColor]="tooltipColor()"></hx-label>
  }

  <div
    class="hx-chip-group-content"
    tabindex="-1"
    [class.hx-chip-group-disabled]="disabled()"
    (keydown)="_handleKeydown($event)"
    role="listbox">
    @for (chip of _processedChips(); track chip.value ?? chip.label) {
      <hx-chip
        class="hx-chip"
        [label]="chip.label"
        [size]="size()"
        [variant]="chip.variant || variant()"
        [disabled]="disabled() || chip.disabled || (!_isSelected(chip.value ?? chip.label) && isLimitReached())"
        [readonly]="readonly()"
        [selected]="_isSelected(chip.value ?? chip.label)"
        (click)="_handleChipClick(chip)" />
    }
    <ng-content />
  </div>

  <!-- Other input field shown when "Other" chip is selected and showInputOnOther is true -->
  @if (showOtherChip() && _otherSelected() && showInputOnOther()) {
    <div class="hx-chip-group-other-input-container">
      <hx-input
        type="text"
        class="hx-chip-group-other-input"
        [label]="otherChipLabel()"
        [placeholder]="otherChipPlaceholder()"
        [formControl]="_otherFormControl"
        [disabled]="disabled() || otherDisabled()"
        [required]="otherInputRequired()"
        (input)="_handleOtherInputChange($event)"
        (keydown)="_handleOtherInputKeydown($event)"
        [attr.aria-label]="'Enter custom value for ' + otherChipLabel()"></hx-input>
    </div>
  }

  <div class="hx-form-subscript-wrapper">
    @if (hint()) {
      <div hx-hint class="hx-form-hint">{{ hint() }}</div>
    }
    @if (_error()) {
      <div hx-error class="hx-form-error" role="alert">{{ _error() }}</div>
    }
  </div>
</hx-form-group>
